module.exports = __webpack_public_path__ + "static/img/mode-bg.dd491ba7.png";